
    import { NumberPicker } from '@alifd/next';
    import type { NumberPickerProps } from '@alifd/next/types/number-picker';
    import wrapper from './next-wrapper';

    export type BLProFormNumberPickerProps =NumberPickerProps;

    const BLProFormNumberPicker = wrapper<BLProFormNumberPickerProps>(NumberPicker, 'BLProFormNumberPicker');

    export default BLProFormNumberPicker;
